export class Notification {
    type: NotificationType;
    header: string;
    // if Array -> for each value of array one bullet point
    messages: string | string[];
    // time to hide automatically
    timeOut?: number;
    // new = displayed for the first time; showagain = a hidden notification is displayed again
    // controls animation
    state: 'new' | 'showagain' | 'hidden' = 'new';
    // controls vsibility, which triggers animation
    visible: boolean;
}
export enum NotificationType {
    Success,
    Error,
    Info,
    Warning
}
